"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Takes a `name` for a modifier and a `styles` object
// and returns a wrapper object with the `&` key, which
// causes `emotion` to split the style definitions apart,
// thereby making them easier to diff in the dev tools.
// This function doesn't change specificity of the styles,
// it only separates them.
var withModifier = function (name, styles) { return ({
    '&[class]': __assign({ label: name && "-" + name }, styles),
}); };
exports.default = withModifier;
